import React, {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';

import _ from 'lodash';
import { isBlank } from 'utils/object';
import { getFormItemList } from './utils';
import './index.less';
import { OptionsContext } from '../DetailLayout/context';
import { getContent } from 'containers/OutBidding/components/utils';
import { FormMode, transformBlobidsToFileList } from '../../utils';
import { CommonForm } from 'containers/OutBidding/components/CommonForm';

const InitFormData: Record<string, any> = {};

const TenderForm = forwardRef((props: any, ref: any) => {
  const {
    prefixCls = 'bidding-tender-form',
    detail = {},
    editFields = [],
  } = props;

  const isEdit = !isBlank(detail);

  const [formData, setFormData] = useState(InitFormData);
  const formRef = useRef<any>();
  const optionsMap = useContext(OptionsContext);

  const getTemplateContent = () => {
    let budgetCurrency = '';
    if (optionsMap && optionsMap.quote_currencies) {
      const item = optionsMap.quote_currencies.find(
        (v: any) => v.value === detail?.budget_currency
      );
      if (item) {
        budgetCurrency = item.name;
      }
    }

    return `${getContent(detail?.product_identifier)}产品，${getContent(
      detail?.expect_begin_at,
      true
    )} / ${getContent(detail?.expect_end_at, true)}，${getContent(
      detail?.name
    )}，项目预算 ${getContent(
      detail?.budget
    )} ${budgetCurrency}，比选提案日期${getContent(
      formData.bid_proposal_deadline,
      true
    )}，请有意合作供应商于${getContent(
      formData.bid_registration_deadline,
      true
    )}前，接受比选需求，审核通过后可获取详细比选资料。`;
  };

  useEffect(() => {
    const newFormData = _.cloneDeep(formData);
    newFormData[
      'announcement_content_concat'
    ] = formData.competition_announcement || getTemplateContent();
    setFormData(newFormData);
  }, [
    formData.competition_announcement,
    formData.bid_proposal_deadline,
    formData.bid_registration_deadline,
    optionsMap,
  ]);

  // 初始化数据（detail.id 变化时重新初始化，修复跨单据缓存问题）
  useEffect(() => {
    if (!isBlank(detail)) {
      const {
        bidding_method,
        bidding_type,
        bidding_supplier_num,
        competition_announcement = '',
        bid_proposal_deadline,
        bidding_out_attachments = [],
        bid_registration_deadline,
        bidding_qa_time,
        bidding_qa_attachments,
      } = detail;

      setFormData({
        bidding_method: bidding_method
          ? bidding_method.toLowerCase()
          : undefined,
        bidding_type: bidding_type ? bidding_type.toLowerCase() : undefined,
        bidding_supplier_num,
        bidding_out_attach_blob_ids: transformBlobidsToFileList(
          bidding_out_attachments
        ),
        bid_proposal_deadline,
        bid_registration_deadline,
        bidding_qa_time,
        bidding_qa_attachments: transformBlobidsToFileList(
          bidding_qa_attachments
        ),
        competition_announcement,
      });
    }
  }, [detail.id]);

  // 对外暴露方法
  useImperativeHandle(ref, () => ({
    validData() {
      if (!(formRef.current && formRef.current.valid())) {
        return false;
      }
      return formData;
    },
  }));

  // 动态渲染 formItem 组件
  const itemList = getFormItemList({
    formData,
    optionsMap,
    setFormData,
    editFields,
    detail,
    getTemplateContent,
  });

  const commonFormProps = {
    formProps: { isLabelVertical: true },
    formItemList: itemList,
  };

  return (
    <div className={prefixCls}>
      {/* Form 组件只有 edit 模式，才会启用非空校验 */}
      <CommonForm
        {...commonFormProps}
        ref={formRef}
        mode={editFields.length ? FormMode.Edit : FormMode.Show}
      />
    </div>
  );
});

export default TenderForm;
